import appconst from '@/lib/appconst'

// 重定向路径需要与后台数据库存储的相匹配
const tokenCofig = {
  authority: appconst.token_root,
  client_id: 'backend-admin-app-client',
  redirect_uri: appconst.appBaseUrl + '/callback',
  // Grant_Type: 'implicit',
  response_type: appconst.response_type,
  scope: appconst.scope,
  post_logout_redirect_uri: appconst.appBaseUrl + '/login'
}
export default tokenCofig